/** Canonical two-line hero for the investor pricing page. */
export const INVESTOR_PRICING_PAGE_HEADLINE = {
  line1: 'Unlock high-potential Startups',
  line2: 'faster & beyond your network',
  full: 'Unlock high-potential Startups faster & beyond your network',
} as const;

export function headlineIncludesUnlockLine(text: string): boolean {
  return /unlock/i.test(text.replace(/\s+/g, ' ').trim());
}

export function isUnitedStatesCountry(country: string): boolean {
  return country.trim() === 'United States';
}

export function isUnitedKingdomCountry(country: string): boolean {
  return country.trim() === 'United Kingdom';
}

/** US states or UK nations — both stored on profile `state`. */
export function countryRequiresStateSubdivision(country: string): boolean {
  return isUnitedStatesCountry(country) || isUnitedKingdomCountry(country);
}
